export default __webpack_public_path__ + "static/media/bginside.7f96679d.png";